import { css } from 'styled-components';
import {
  CtaWrapper,
  Heading,
  HeadingsWrapper,
  Subheading,
} from '../../../../components/Video/FeatureVideo/styles';
import spacing from '../../../../helpers/spacing';
import { fonts } from '../../fonts';

export default css`
  ${HeadingsWrapper} {
    margin-bottom: ${spacing(3)};
  }

  ${Heading} {
    text-align: left;
    line-height: 44px;
  }

  ${Subheading} {
    ${fonts.paragraphLarge}
    text-align: left;
    margin-top: ${spacing(2)};
  }

  ${CtaWrapper} {
    justify-content: left;
  }
`;
